import {
  Assignment,
  Comment,
  EmailOutlined,
  FactCheck,
  FolderOpen,
  Payment,
  SupportAgent,
  Translate,
} from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  Divider,
  Grid,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import TextFieldComponent from "../../../../../Components/TextFieldComponent";
import Btn from "../../../../../Components/Ui_elements/Btn";
import GenericTable from "../../../../../Components/Ui_elements/GenericTable";
import PopupModal from "../../../../../Components/Ui_elements/PopupModal";
import { localizeNumber } from "../../../../../Helper/generalhelper";
import { getCenteredPopupSize } from "../../../../../Helper/Constants";
import { showSnackbar } from "../../../../../redux/Slice/snackbar/snackbarSlice";
import { getJobSourceTragetFilesTotal } from "../../../../../redux/Thunk/DashboardModule/DashboardThunk";
import {
  acceptJobStatus,
  jobSummeryDetailsGet,
  jobSummeryWorkinstructUpdate,
  rejectJobStatus,
  sendjobResourceMsg,
} from "../../../../../redux/Thunk/FreelanceScreenThunk/FreelanceThunk";
import EmailClient from "../../../../Admin/A_System/Templates/EmailClient";

function JobDetailsForMailTemplat() {
  const [jobDetails, setJobDetails] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { job_summary } = useSelector(state => state.root.FreelanceModule);
  const { user } = useSelector(state => state?.root?.authUser);
  const { id } = useParams();
  const emailRef = useRef();
  const [openEmail, setOpenEmail] = useState(false);
  const [fileManagerCounts, setSetFileManagerCounts] = useState({ in_count: 0, out_count: 0 });
  const [workInstructions, setWorkInstructions] = useState([]);
  const [openAccept, setOpenAccept] = useState(false);
  const [isReject, setIsReject] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const { width, height, left, top } = getCenteredPopupSize(0.5, 0.7);

  useEffect(() => {
    dispatch(jobSummeryDetailsGet(id));
  }, [id, dispatch]);

  useEffect(() => {
    const fetchAndSetFileCounts = async () => {
      if (job_summary?.data?.job_summmeryId)
        dispatch(getJobSourceTragetFilesTotal(job_summary?.data?.job_summmeryId)).then(res => {
          if (res) {
            setSetFileManagerCounts({
              out_count: res?.payload?.data?.[0]?.in_count,
              in_count: res?.payload?.data?.[0]?.out_count,
            });
          }
        });
    };
    fetchAndSetFileCounts();
    window.refreshFileManagerCount = fetchAndSetFileCounts;
  }, [job_summary, dispatch]);

  useEffect(() => {
    const raw = job_summary?.data?.work_instruction;
    try {
      const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
      if (Array.isArray(parsed)) {
        setWorkInstructions(
          parsed.map((item, index) => ({
            work_id: item?.work_id ?? index,
            work_name: item?.work_name || "",
            work_checked: !!item?.work_checked,
          }))
        );
      } else {
        setWorkInstructions([]);
      }
    } catch (err) {
      console.error("Failed to parse work_instruction on update:", err);
      setWorkInstructions([]);
    }
  }, [job_summary?.data?.work_instruction]);

  useEffect(() => {
    if (!job_summary?.data) return;

    const jobData = job_summary?.data;
    const isLinguist = user?.iFkUserTypeId === 2;
    const iUserId = user?.iUserId;
    const freelanceId = Number(jobData?.resource);
    if (isLinguist && iUserId !== freelanceId) {
      navigate("/");
    } else {
      const modifiedData = {
        po_number: jobData?.po_number,
        due_date: jobData?.due_date,
        job_summmeryId: jobData?.job_summmeryId,
        item_status: jobData?.item_status,
        projectManager: jobData?.projectManager,
        item_id: jobData?.item_id,
        ItemLanguage: jobData?.ItemLanguage,
        resource: jobData?.userName,
        description: jobData?.description,
        job_payment_note: jobData?.job_payment_note,
        work_instruction: jobData?.work_instruction ? JSON.parse(jobData?.work_instruction) : [],
        price: jobData?.price ? JSON.parse(jobData?.price) : [],
        company_code: jobData?.company_code,
        total_price: jobData?.total_price,
        created_date: jobData?.created_date,
      };
      setJobDetails(modifiedData);
    }
  }, [job_summary?.data, user, navigate]);

  const rawItemLanguage = job_summary?.data?.ItemLanguage || "";
  let formattedLanguage = "";

  try {
    if (rawItemLanguage && rawItemLanguage.includes("{")) {
      const parts = rawItemLanguage
        .split(/}>\s*{/)
        .map((part, index, arr) => {
          if (!part.trim()) return null;
          if (index !== 0) part = "{" + part;
          if (index !== arr.length - 1) part = part + "}";
          return JSON.parse(part);
        })
        .filter(Boolean);

      formattedLanguage = parts
        .map(p => p.sourceLang)
        .filter(Boolean)
        .join(" > ");
    }
  } catch (e) {
    console.warn("Failed to parse ItemLanguage:", e);
  }

  const handleCheckboxChange = work_id => {
    const updated = workInstructions.map(instruction =>
      instruction.work_id === work_id
        ? { ...instruction, work_checked: !instruction.work_checked }
        : instruction
    );
    setWorkInstructions(updated);
    dispatch(jobSummeryWorkinstructUpdate({ id: jobDetails?.job_summmeryId, payload: updated }))
      .unwrap()
      .then(() => {
        dispatch(showSnackbar({ message: "Work instruction updated successfully", type: "success" }));
      });
  };

  const handleAccept = jobType => {
    const payload = {
      ...(jobType === "accept" && { acceptJobType: jobType }),
      item_status: "Ongoing",
      userId: user?.iUserId,
    };
    dispatch(acceptJobStatus({ id: id, payload: payload })).then(() => {
      setOpenAccept(false);
      dispatch(jobSummeryDetailsGet(id));
    });
  };

  const handleCompleted = () => {
    const payload = { item_status: "Completed" };
    dispatch(acceptJobStatus({ id: id, payload: payload })).then(() => {
      dispatch(jobSummeryDetailsGet(id));
    });
  };

  const handleReject = () => {
    if (!rejectReason.trim()) {
      dispatch(showSnackbar({ message: "Please provide a reason for rejection", type: "error" }));
      return;
    }
    const payload = {
      rejection: rejectReason,
      userId: user?.iUserId,
    };
    dispatch(rejectJobStatus({ id: id, payload: payload })).then(() => {
      setIsReject(false);
      dispatch(jobSummeryDetailsGet(id));
    });
  };

  const handleSubmitMail = async () => {
    if (emailRef.current && emailRef.current.handleSubmit) {
      try {
        const response = await emailRef.current.handleSubmit();
        if (response !== null) {
          const payload = {
            ...response,
            data: {
              ...response.data,
              vUserName: job_summary?.data?.contactPerson,
            },
          };
          dispatch(sendjobResourceMsg(payload));
          setOpenEmail(false);
        }
      } catch (error) {
        console.error("Failed to send email:", error);
      }
    }
  };

  const columns = [
    { name: "quantity", label: "Quantity", options: { sort: true } },
    { name: "pricelist", label: "Price Unit", options: { sort: true } },
    { name: "itemPrice", label: "Unit Price", options: { sort: true } },
    {
      name: "itemTotal",
      label: `Amount in ${job_summary?.data?.freelance_currency || "EUR"} ${localizeNumber(jobDetails?.total_price)} `,
      options: {
        customBodyRender: value => {
          return localizeNumber(Number(value));
        },
      },
    },
  ];

  return (
    <>
      <Box sx={{ backgroundColor: "#f8f9fd", p: 3, borderRadius: 2 }}>
        <Box>
          {/* Header Information Cards */}
          <Grid container spacing={3}>
            {/* Basic Job Details */}
            <Grid item xs={12} md={5}>
              <Card
                sx={{
                  height: "100%",
                  borderRadius: 3,
                  boxShadow: "0 2px 12px 0 rgba(0,0,0,0.04)",
                  border: "1px solid #edf0f5",
                }}
              >
                <CardContent>
                  <Typography
                    variant="overline"
                    color="text.secondary"
                    fontWeight={700}
                    gutterBottom
                    sx={{ display: "flex", alignItems: "center", gap: 1 }}
                  >
                    <Assignment sx={{ fontSize: 16 }} /> Job Details
                  </Typography>
                  <Stack spacing={1.5} mt={1}>
                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                      <Typography variant="body2" color="text.secondary">Number:</Typography>
                      <Typography variant="body2" fontWeight={600}>{jobDetails?.po_number || "—"}</Typography>
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                      <Typography variant="body2" color="text.secondary">Resource:</Typography>
                      <Typography variant="body2" fontWeight={600}>{jobDetails?.resource || "—"}</Typography>
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                      <Typography variant="body2" color="text.secondary">Status:</Typography>
                      <Box
                        sx={{
                          px: 1,
                          py: 0.2,
                          borderRadius: 1,
                          bgcolor: jobDetails?.item_status === "Ongoing" ? "#e3f2fd" : "#f5f5f5",
                          color: jobDetails?.item_status === "Ongoing" ? "#1976d2" : "inherit",
                          fontSize: "0.75rem",
                          fontWeight: 700,
                        }}
                      >
                        {jobDetails?.item_status || "—"}
                      </Box>
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                      <Typography variant="body2" color="text.secondary">Due Date:</Typography>
                      <Typography variant="body2" fontWeight={600} color="error.main">
                        {jobDetails?.due_date &&
                          jobDetails.due_date !== "0000-00-00 00:00:00" &&
                          dayjs(jobDetails.due_date).isValid()
                          ? dayjs(jobDetails.due_date).format("DD MMM YYYY, HH:mm")
                          : "—"}
                      </Typography>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>

            {/* Project Information */}
            <Grid item xs={12} md={5}>
              <Card
                sx={{
                  height: "100%",
                  borderRadius: 3,
                  boxShadow: "0 2px 12px 0 rgba(0,0,0,0.04)",
                  border: "1px solid #edf0f5",
                }}
              >
                <CardContent>
                  <Typography
                    variant="overline"
                    color="text.secondary"
                    fontWeight={700}
                    gutterBottom
                    sx={{ display: "flex", alignItems: "center", gap: 1 }}
                  >
                    <SupportAgent sx={{ fontSize: 16 }} /> Project Info
                  </Typography>
                  <Stack spacing={1.5} mt={1}>
                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                      <Typography variant="body2" color="text.secondary">Created:</Typography>
                      <Typography variant="body2" fontWeight={600}>
                        {jobDetails?.created_date ? dayjs(jobDetails.created_date).format("DD.MM.YYYY") : "—"}
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: 'center' }}>
                      <Typography variant="body2" color="text.secondary">Language:</Typography>
                      <Typography variant="body2" fontWeight={600} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <Translate sx={{ fontSize: 14, color: 'primary.main' }} /> {formattedLanguage || "—"}
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <Typography variant="body2" color="text.secondary">Manager:</Typography>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography variant="body2" fontWeight={600}>{jobDetails?.projectManager || "—"} {jobDetails?.contactPersonEmail}</Typography>
                        <IconButton
                          size="small"
                          // onClick={() => setOpenEmail(true)}
                          onClick={() =>
                            (window.location.href = `mailto:${job_summary?.data?.contactPersonEmail}?subject=${jobDetails?.po_number || ""}`)
                          }
                          sx={{ ml: 0.5, p: 0.5 }}
                        >
                          <EmailOutlined sx={{ fontSize: 16, color: "primary.main" }} />
                        </IconButton>
                      </Box>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>

          </Grid>

          {/* File Manager Buttons */}
          <Box mt={3} mb={3}>
            <Stack direction="row" spacing={2}>
              <Button
                variant="contained"
                disableElevation
                sx={{
                  borderRadius: 2,
                  textTransform: "none",
                  px: 3,
                  bgcolor: "#6366f1",
                  "&:hover": { bgcolor: "#4f46e5" },
                }}
                onClick={() =>
                  window.open(
                    `/filemanage/item?jobId=${jobDetails?.job_summmeryId}&sourceTargetType=_out`,
                    "FileManagerPopup",
                    `width=${width},height=${height},top=${top},left=${left},` +
                    "menubar=no,toolbar=no,location=no,status=no,scrollbars=yes,resizable=yes"
                  )
                }
              >
                <FolderOpen sx={{ fontSize: 18, mr: 1 }} />
                Deliverables ({fileManagerCounts?.in_count ?? 0})
              </Button>

              <Button
                variant="outlined"
                sx={{
                  borderRadius: 2,
                  textTransform: "none",
                  px: 3,
                  borderColor: "#6366f1",
                  color: "#6366f1",
                  "&:hover": { borderColor: "#4f46e5", bgcolor: "#f5f6ff" },
                }}
                onClick={() =>
                  window.open(
                    `/filemanage/item?jobId=${jobDetails?.job_summmeryId}&sourceTargetType=_in`,
                    "FileManagerPopup",
                    `width=${width},height=${height},top=${top},left=${left},` +
                    "menubar=no,toolbar=no,location=no,status=no,scrollbars=yes,resizable=yes"
                  )
                }
              >
                <FolderOpen sx={{ fontSize: 18, mr: 1 }} />
                References ({fileManagerCounts?.out_count ?? 0})
              </Button>
            </Stack>
          </Box>

          {/* Main Content Area: Comment & Work Instructions */}
          <Grid container spacing={3}>
            {/* Comment Section */}
            <Grid item xs={12} md={10}>
              <Card
                sx={{
                  borderRadius: 3,
                  boxShadow: "0 4px 20px 0 rgba(0,0,0,0.05)",
                  border: "2px solid #ebf0ff",
                  height: "100%",
                  bgcolor: "#fff",
                }}
              >
                <CardContent>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
                    <Comment sx={{ color: "primary.main" }} />
                    <Typography variant="h6" fontWeight={700}>
                      Comment / Instructions
                    </Typography>
                  </Box>
                  <Divider sx={{ mb: 2 }} />
                  <Typography
                    variant="body1"
                    sx={{
                      whiteSpace: "pre-line",
                      color: "text.primary",
                      lineHeight: 1.7,
                      p: 2,
                      bgcolor: "#fcfdff",
                      borderRadius: 2,
                      border: "1px solid #f0f4ff",
                      minHeight: "150px"
                    }}
                  >
                    {job_summary?.data?.jobDesc || <span style={{ color: '#aaa', fontStyle: 'italic' }}>No comments provided for this job.</span>}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            {/* Compact Job action */}
            {/*<Grid item xs={12} md={5}>
              <Card
                sx={{
                  borderRadius: 3,
                  boxShadow: "0 2px 12px 0 rgba(0,0,0,0.04)",
                  border: "1px solid #edf0f5",
                  height: "100%",
                }}
              >
                <CardContent>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
                    <FactCheck sx={{ color: "success.main" }} />
                    <Typography variant="h6" fontWeight={700}>
                      Job Action
                    </Typography>
                  </Box>
                  <Divider sx={{ mb: 2 }} />
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
                    {job_summary?.data?.item_status === "Requested" && (
                      <>
                        <Button
                          variant="contained"
                          fullWidth
                          size="large"
                          sx={{
                            bgcolor: "#8b5cf6",
                            borderRadius: 2,
                            fontWeight: 600,
                            "&:hover": { bgcolor: "#7c3aed" },
                          }}
                          onClick={() => setOpenAccept(true)}
                        >
                          Accept Job
                        </Button>

                        <Button
                          variant="outlined"
                          fullWidth
                          color="error"
                          size="large"
                          sx={{ borderRadius: 2, fontWeight: 600 }}
                          onClick={() => setIsReject(true)}
                        >
                          Reject Job
                        </Button>
                      </>
                    )}
                    {(job_summary?.data?.item_status === "In-progress" || job_summary?.data?.item_status === "Ongoing") && (
                      <Button
                        variant="contained"
                        fullWidth
                        size="large"
                        color="success"
                        sx={{ borderRadius: 2, fontWeight: 600 }}
                        onClick={handleCompleted}
                      >
                        Complete Job
                      </Button>
                    )}
                    {(job_summary?.data?.item_status === "Assigned-waiting" || job_summary?.data?.item_status === "Waiting") && (
                      <Button
                        variant="contained"
                        fullWidth
                        size="large"
                        sx={{
                          bgcolor: "#8b5cf6",
                          borderRadius: 2,
                          fontWeight: 600,
                          "&:hover": { bgcolor: "#7c3aed" },
                        }}
                        onClick={() => handleAccept("start")}
                      >
                        Start Job
                      </Button>
                    )}
                    {!["Requested", "In-progress", "Ongoing", "Assigned-waiting", "Waiting"].includes(job_summary?.data?.item_status) && (
                      <Typography variant="body2" color="text.secondary" align="center" sx={{ fontStyle: 'italic', py: 2 }}>
                        No further actions required for current status.
                      </Typography>
                    )}
                  </Box>
                </CardContent>
              </Card> 
            </Grid> */}

            {/* Work Instructions Section */}
            {/*<Grid item xs={12} md={4}>
               <Card
                sx={{
                  height: "100%",
                  borderRadius: 3,
                  boxShadow: "0 2px 12px 0 rgba(0,0,0,0.04)",
                  border: "1px solid #edf0f5",
                  bgcolor: "#fafafa"
                }}
              >
                <CardContent sx={{ p: "16px !important" }}>
                  <Typography
                    variant="overline"
                    color="text.secondary"
                    fontWeight={700}
                    sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}
                  >
                    <Assignment sx={{ fontSize: 16 }} /> Work Instructions
                  </Typography>
                  <Box
                    sx={{
                      maxHeight: 250,
                      overflowY: "auto",
                      border: "1px solid #eee",
                      borderRadius: 2,
                      bgcolor: "#fff",
                    }}
                  >
                    <Table size="small" stickyHeader>
                      <TableBody>
                        {workInstructions.length > 0 ? (
                          workInstructions.map(instruction => (
                            <TableRow key={instruction.work_id} hover>
                              <TableCell sx={{ py: 0.5, borderBottom: "1px solid #f0f0f0", fontSize: '0.75rem' }}>
                                {instruction.work_name}
                              </TableCell>
                              <TableCell align="right" sx={{ py: 0.5, borderBottom: "1px solid #f0f0f0" }}>
                                <Checkbox
                                  size="small"
                                  checked={instruction.work_checked}
                                  onChange={() => handleCheckboxChange(instruction.work_id)}
                                  sx={{ p: 0 }}
                                />
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell align="center" sx={{ py: 2, color: "text.disabled", fontSize: '0.75rem' }}>
                              No instructions
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </Box>
                </CardContent>
              </Card> 
            </Grid> */}


            {/* Financial Details Table */}
            <Grid item xs={12} md={10}>
              <Card sx={{ borderRadius: 3, overflow: "hidden", border: "1px solid #edf0f5" }}>
                <CardContent>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
                    <Payment sx={{ color: "primary.main" }} />
                    <Typography variant="h6" fontWeight={700}>
                      Payment Details
                    </Typography>
                  </Box>
                  <Divider sx={{ mb: 2 }} />

                  <GenericTable
                    columns={columns}
                    data={
                      jobDetails?.price?.map((row, index) => ({
                        ...row,
                        rowNumber: index + 1,
                      })) || []
                    }
                    showAction={false}
                    displayColumns={4}
                    displayRows={100}
                    showSearchBox={false}
                    showPagination={false}
                    hideToolbar={true}
                  />
                  {/* {jobDetails?.total_price && (
                  <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end', bgcolor: "#fafafa", borderTop: "1px solid #edf0f5", mt: 2 }}>
                    <Typography variant="subtitle1" fontWeight={700}>
                      Total Net Price: {localizeNumber(jobDetails?.total_price)}
                    </Typography>
                  </Box>
                )} */}
                </CardContent>
              </Card>
            </Grid>
          </Grid>

        </Box>
      </Box>

      {openAccept && (
        <PopupModal
          open={openAccept}
          maxWidth="sm"
          width="600px"
          title="Accept Job"
          handleClose={() => setOpenAccept(false)}
          actions={
            <>
              <Btn onClick={() => handleAccept("accept")}>Yes, Accept</Btn>
              <Btn variant="outlined" onClick={() => setOpenAccept(false)}>Cancel</Btn>
            </>
          }
        >
          <Typography variant="body1">Are you sure you want to accept this job?</Typography>
        </PopupModal>
      )
      }

      {
        isReject && (
          <PopupModal
            open={isReject}
            maxWidth="sm"
            width="600px"
            title="Reject Job"
            handleClose={() => setIsReject(false)}
            actions={
              <>
                <Btn onClick={handleReject}>Reject Job</Btn>
                <Btn variant="outlined" onClick={() => setIsReject(false)}>Cancel</Btn>
              </>
            }
          >
            <Box pt={1}>
              <TextFieldComponent
                label="Reason for Rejection"
                value={rejectReason}
                onChange={e => setRejectReason(e.target.value)}
                placeholder="Please enter the reason for rejecting this job"
                multiline
                rows={4}
                fullWidth
              />
            </Box>
          </PopupModal>
        )
      }

      {
        openEmail && (
          <PopupModal
            open={openEmail}
            maxWidth="lg"
            title="Mail"
            handleClose={() => setOpenEmail(false)}
            actions={
              <>
                <Btn onClick={handleSubmitMail}>Send Mail</Btn>
                <Btn variant="outlined" onClick={() => setOpenEmail(false)}>Cancel</Btn>
              </>
            }
          >
            <EmailClient
              ref={emailRef}
              general={true}
              userName={job_summary?.data?.userName}
              invoiceNumber={job_summary?.data?.po_number}
              email={job_summary?.data?.contactPersonEmail || ""}
              showFromProfile={true}
            />
          </PopupModal>
        )
      }
    </>
  );
}

export default JobDetailsForMailTemplat;
